export default () => {
  const init = () => {
    customElements.define("form-validation", FormValidation);
  };
  init();
};

class FormValidation extends HTMLElement{
  constructor() {
    super();
    this.validateEmail = this.validateEmail.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.showRecoveryForm = this.showRecoveryForm.bind(this);
    this.showLoginForm = this.showLoginForm.bind(this);
    this.translations = window.SS.Strings.errorsMessage;
  }

  connectedCallback(){
    this.form = this.querySelector('#login-form') ? this.querySelector('#login-form') : null;
    this.emailInput = this.querySelector('#CustomerEmail') ? this.querySelector('#CustomerEmail') : null;
    this.passwordInput = this.querySelector('#CustomerPassword') ? this.querySelector('#CustomerPassword') : null;
    this.recoveryEmailInput = this.querySelector('#RecoverEmail') ? this.querySelector('#RecoverEmail') : null;
    this.recoveryEmailError = this.querySelector('#recoveryEmailError') ? this.querySelector('#recoveryEmailError') : null;
    this.emailError = this.querySelector('#emailError') ? this.querySelector('#emailError') : null;
    this.passwordError = this.querySelector('#passwordError') ? this.querySelector('#passwordError') : null;
    this.loginForm = this.querySelector('.login-form') || null;
    this.recoveryForm = this.querySelector('.password-recovery') || null;
    this.backToLoginButton = this.querySelector('.back-to-login') || null;
    this.forgotPasswordButton = this.querySelector('.recover-password-button') || null;
    this.recoverForm = this.querySelector('#recoverForm') || null;
    this.recoverBackToLogin = this.querySelector('.recover-succes__login-button') || null;

    if (window.location.hash === '#recover' || localStorage.getItem('showRecoveryForm')) {
      this.showRecoveryForm();
      localStorage.removeItem('showRecoveryForm', 'true');
    } else {
      this.showLoginForm();
    }

    this.initEventListeners();
  }

  initEventListeners() {
    this.emailInput.addEventListener('input', () => this.validateEmail(this.emailInput, this.emailError));
    this.recoveryEmailInput.addEventListener('input', () => this.validateEmail(this.recoveryEmailInput, this.recoveryEmailError));
    this.passwordInput.addEventListener('input', () => this.validatePassword());
    this.form.addEventListener('submit', (e) => this.validateForm(e));
    this.forgotPasswordButton.addEventListener('click',() => this.showRecoveryForm());
    this.backToLoginButton.addEventListener('click',() => this.showLoginForm());
    this.recoverBackToLogin?.addEventListener('click',() => this.showLoginForm());
  }

  disconnectedCallback() {
    this.emailInput.removeEventListener('input', this.validateEmail);
    this.recoveryEmailInput.removeEventListener('input', this.validateEmail);
    this.passwordInput.removeEventListener('input', this.validatePassword);
    this.form.removeEventListener('submit', this.validateForm);
    this.forgotPasswordButton.removeEventListener('click', this.showRecoveryForm);
    this.backToLoginButton.removeEventListener('click', this.showLoginForm);
    this.recoverBackToLogin.removeEventListener('click',() => this.showLoginForm());
  }

  showRecoveryForm() {
    this.loginForm.classList.add('hidden');
    this.recoveryForm.classList.remove('hidden');
    localStorage.setItem('showRecoveryForm', 'true');
    window.history.pushState(null, '', '#recover');
  }

  showLoginForm() {
    this.loginForm.classList.remove('hidden');
    this.recoveryForm.classList.add('hidden');
    window.history.pushState(null, '', '#login');
  }

  validateEmail(inputElement, errorElement) {
    const email = inputElement.value.trim();
    const elementError = errorElement;
    const regex = /^\S+@\S+\.\S+$/;
    const isValid = regex.test(email) && email.length > 0;

    if (!isValid) {
      elementError.textContent = this.translations.emailErrorMessage;
      inputElement.classList.add('error-message');
      this.form.querySelector('.login-submit').setAttribute('disabled', true)
    } else {
      elementError.textContent = '';
      inputElement.classList.remove('error-message');
      this.form.querySelector('.login-submit').removeAttribute('disabled')
    }

    return isValid;
  }

  validatePassword() {
    const password = this.passwordInput.value.trim();
    const isValid = password.length >= 5;

    if (!isValid) {
      this.passwordError.textContent = this.translations.passwordErrorMessage;
      this.passwordInput.classList.add('error-message');
      this.form.querySelector('.login-submit').setAttribute('disabled', true)
    } else {
      this.passwordError.textContent = '';
      this.passwordInput.classList.remove('error-message');
      this.form.querySelector('.login-submit').removeAttribute('disabled')
    }

    return isValid;
  }

  validateForm(e) {
    e.preventDefault();

    const isEmailValid = this.validateEmail();
    const isPasswordValid = this.validatePassword();

    if (isEmailValid && isPasswordValid) {
      this.form.submit();
    }
  }
}
